import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { fadeUp, stagger } from "../lib/motion";
import { TESTIMONIALS } from "../lib/site";

export const Testimonials = () => (
  <section className="relative py-28 lg:py-36 grid-bg" data-testid="testimonials-section">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-100px" }}
        variants={stagger}
        className="mb-16"
      >
        <motion.p variants={fadeUp} className="text-xs font-bold uppercase tracking-[0.3em] text-[#C6FF00] mb-5">
          / Client Voices
        </motion.p>
        <motion.h2 variants={fadeUp} className="text-5xl lg:text-7xl font-black uppercase tracking-tighter leading-[0.9]">
          They grew<br />bolder
        </motion.h2>
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
        variants={stagger}
        className="grid grid-cols-1 md:grid-cols-3 gap-6"
      >
        {TESTIMONIALS.map((t, i) => (
          <motion.blockquote
            key={t.name || t.quote || i}
            variants={fadeUp}
            whileHover={{ y: -8 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            className="relative bg-[#111317] border border-[#2A2D34] p-8 lg:p-10 flex flex-col justify-between hover:border-[#C6FF00]/50"
            data-testid={`testimonial-${i}`}
          >
            <Quote className="h-10 w-10 text-[#C6FF00] mb-6" />
            <p className="text-lg lg:text-xl font-semibold leading-relaxed text-white/90 mb-8">
              “{t.quote}”
            </p>
            <footer className="border-t border-[#2A2D34] pt-5">
              <p className="font-bold uppercase tracking-tight">{t.name}</p>
              <p className="text-sm text-[#8A939B] font-medium">{t.role}</p>
            </footer>
          </motion.blockquote>
        ))}
      </motion.div>
    </div>
  </section>
);
